import { SearchConfig } from "@/components/dynamic-form";
import { SearchBarType } from "@/components/dynamic-form/constants";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function getChildManageSearchConfig(): SearchConfig[] {
  const t = getTranslateNsT("center");
  return [
    {
      type: SearchBarType.Input,
      field: "userName",
      label: t("user_com_childManage_head_sub_name"),
      props: {
        placeholder: t("user_com_childManage_head_sub_name"),
      },
    },
  ];
}
